<ng-template #template>
  <div class="sv-skeleton-element" [id]="element.id" [style.height]="element.skeletonHeight"></div>
</ng-template>